import React, { useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, CircularProgress, Container, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material';
import '../App.css';
import Navbar from '../Components/Navbar';
import * as API from "../External/APIcalls";
import { formatToPrice } from "../External/GeneralFunctions";
import { useCookies } from 'react-cookie';
import mainTheme from "../Themes";
import BasicCollapsibleTable from '../Components/BasicCollapsibleTable';
import SearchBar from '../Components/SearchBar';
import Footer from '../Components/Footer';
import { DataGrid } from '@mui/x-data-grid';
import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  LensTwoTone,
} from '@mui/icons-material';
import BasicTable from '../Components/BasicTable';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';

// Calculate the current year
const currentYear = new Date().getFullYear();

// Generate an array of years from 2023 to the current year
const years: any[] = [];
for (let year = 2023; year <= currentYear; year++) {
  years.push(year);
}
years.reverse();

const getData = async (auth: string) => {
    const headers = {
      "Content-Type": "application/json",
      "X-API-Key": auth
    }
    
    const response = await fetch("https://vmi2.innospecportal.com/api/inventory/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          "region": "us"
        })
    });
    
    if (!response.ok) {
        console.error("RESPONSE NOT OK! " + response.statusText);
    	return [];
    }

    return await response.json();
}

const getDataSuperAdmin = async (auth: string, id: string) => {
    const headers = {
      "Content-Type": "application/json",
      "X-API-Key": auth
    }
    
    const response = await fetch("https://vmi2.innospecportal.com/api/inventory/", {
        method: "POST",
        headers: headers,
	      body: JSON.stringify({
	        "idCustomer": id,
          "region": "us"
	      })
    });
    
    if (!response.ok) {
        console.error("RESPONSE NOT OK! " + response.statusText);
    	return [];
    }

    return await response.json();
}

let dataList: any[];

function Map() {
  const [cookies] = useCookies(["authKey", "userId", "userStatus"]);
  const [userId, setUserId] = useState<string>("");
  const [searchQueryTerm, setSearchQueryTerm] = useState<string>("");
  const [searchQueryStat, setSearchQueryStat] = useState<string>("");
  const [searchQueryProd, setSearchQueryProd] = useState<string>("");
  const [order, setOrder] = useState<'asc' | 'desc'>('asc');
  const [orderBy, setOrderBy] = useState<string>('');
  const [summaryOriginal, setSummaryOriginal] = useState<any[]>([]);
  const [summaryFiltered, setSummaryFiltered] = useState<any[]>([]);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
  const [updatedTimestamp, setUpdatedTimestamp] = useState<string>("");
  const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);
  const [allCustomersList, setAllCustomersList] = useState<any[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<any>({ id: "none", name: "None" });
  const [uniqueTerminalPositions, setUniqueTerminalPositions] = useState<Object[]>([]);
  const [selectedMarker, setSelectedMarker] = useState<any>(null);
  const [mapCenterPos, setMapCenterPos] = useState<any>({ lat: 0, lng: 0 });

  // Google Maps Logic
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLEMAPS_KEY || "", // Move to .ENV
  });

  const [map, setMap] = useState(null);

  const onMapLoad = useCallback(function callback(map: any) {
    // Usage
    

    setMap(map);
  }, []);

  const onMapUnmount = useCallback(function callback(map: any) {
    setMap(null);
  }, []);

  // React effects
  useEffect(() => {
    if (!cookies.authKey || cookies.authKey === "undefined") {
      console.log("No authKey present, kicking user to login screen.");
      window.location.href = "/login";
    }
  }, [cookies]);

  const handleChangeCustomer = (event: SelectChangeEvent) => {
    for (let i = 0; i < allCustomersList.length; i++) {
      if (allCustomersList[i].name === (event.target.value as string)) {
      	setSelectedCustomer(allCustomersList[i]);
      }
    }
  }

  useEffect(() => {
    const fetch = async () => {
      //@ts-expect-error
      document.getElementById("circular-progress-object").style.visibility = "visible";

      try {
        //const user = cookies["userId"];
        //setUserId(user);
	      setIsSuperAdmin(cookies["userStatus"] === "Super Admin" || cookies["userStatus"] === "Super%20Admin");
	      //@ts-expect-error
	      setAllCustomersList(JSON.parse(localStorage.getItem("customerList")));
	      //console.log(isSuperAdmin);
	      let foundData: any[];
	
	      if (isSuperAdmin) {
	          foundData = await getDataSuperAdmin(cookies.authKey, selectedCustomer.id);
	      } else {
	          foundData = await getData(cookies.authKey);
	      }
        //let manipulatedYearlyData: any[] = foundData;

        //console.log(manipulatedYearlyData);

        /*
        //Get timestamp
        const date = new Date();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        
        // Extract components of the time
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        // Format the date and time into the desired string format
        const formattedString = `Last Updated on ${month}-${day}-${year} at ${hours}:${minutes}`;*/

        // Round all floats
        //for (let i = 0; i < foundData.length; i++) {
        //  foundData[i].fieldData.dailyUsage = foundData[i].fieldData.dailyUsage.toFixed(2);
        //}

        let uniqueTerms: Object[] = [];
        let totalLng = 0;
        let totalLat = 0;
        let cnt = 0;

        console.log(foundData);

        // N/A all empty fields
        foundData.forEach(obj => {
          //@ts-expect-error
          const exists = uniqueTerms.some(uniO => uniO.terminal === obj.fieldData.nameTerminal);
          if (!exists) {
            uniqueTerms.push({
              terminal: obj.fieldData.nameTerminal,
              lng: obj.fieldData.longitude,
              lat: obj.fieldData.latitude,
              color: obj.fieldData.flagMarker
            });

            totalLng += obj.fieldData.longitude;
            totalLat += obj.fieldData.latitude;
            cnt++;
          }
        });

        console.log(uniqueTerms);

        setMapCenterPos({ lng: (totalLng / cnt), lat: (totalLat / cnt) });
        setUniqueTerminalPositions(uniqueTerms);
        //console.log(uniqueTerms);
        
        //setUpdatedTimestamp(formattedString);
        //setSummaryOriginal(foundData);
        //setSummaryFiltered(foundData); // Initially set both states to the fetched data

        /*summaryOriginal.map((row, rowIndex) => {
          console.log(row.fieldData);          
        });*/
        
        //@ts-expect-error
        document.getElementById("circular-progress-object").style.visibility = "hidden";
      } catch (error) {
        console.error('Error fetching:', error);
      }
    }

    fetch();
  }, [selectedCustomer]); // Add selectedYear as a dependency

  return (
<div className="App">
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      width: '100vw',          // strict viewport width
      overflowX: 'hidden',     // block horizontal scroll
      boxSizing: 'border-box', // include padding/border in width
    }}
  >
    {/* Navbar */}
    <Navbar username="User" />

    {/* Scrollable Content */}
    <Box
      sx={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'auto',
        width: '100%',             // full width
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          width: '100%',
          px: 2,
          py: 1,
          maxWidth: '100vw',       // limit max width strictly
          boxSizing: 'border-box',
        }}
      >
        <Grid
          container
          sx={{
            width: '100%',
            maxWidth: '100%',
            flexWrap: 'wrap',
            gap: 1,
            boxSizing: 'border-box',
          }}
          alignItems="center"
        >
        {isSuperAdmin ?
        	<FormControl fullWidth sx={{ maxWidth: "12%", backgroundColor: "#ffffff", mr: 2 }}>
                        <InputLabel id="demo-simple-select-label" sx={{color: selectedCustomer.id === "none" ? "red" : ""}}>Select Customer</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedCustomer.name}
                          label="Select Customer"
                          onChange={handleChangeCustomer}
                          size="small" 
                          sx={{ height: "45px" }}
                        >
                          {allCustomersList.map((item) => (
                            <MenuItem key={item.name} value={item.name}>
                              {item.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
        	      : <></>
        	}

          <CircularProgress
            sx={{
              transform: 'scale(0.6)',
              visibility: 'visible',
            }}
            id="circular-progress-object"
          />

          <Box
            sx={{
              width: '100%',
              overflowX: 'auto',         // scroll only if table forces it
              boxSizing: 'border-box',
            }}
          >

            {
              isLoaded ? 
              <GoogleMap
                mapContainerStyle={{ width: '100%', height: 'calc(100vh - 160px)' }}
                center={mapCenterPos}
                zoom={6}
                onLoad={onMapLoad}
                onUnmount={onMapUnmount}
              >
                {
                  uniqueTerminalPositions.map((position, i) => {
                    //@ts-expect-error
                    const isSelected = selectedMarker?.terminal === position.terminal;

                    let markerColor: string = "#ff0000"; // Fallback
                    //@ts-expect-error
                    if (position.color === 0) {
                      markerColor = "#FF2611";
                      //@ts-expect-error
                    } else if (position.color === 1) {
                      markerColor = "#FD9A00";
                    } else {
                      markerColor = "#66B132";
                    }

                    return (<Marker
                      key={i}
                      //@ts-expect-error
                      position={{ lng: position.lng, lat: position.lat }}
                      icon={{
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 6,
                        fillColor: markerColor,
                        fillOpacity: 1,
                        strokeWeight: 1,
                        strokeColor: "#ffffff"
                      }}
                      onClick={(e) => {setSelectedMarker((prev: any) => {
                        console.log(position);
                        
                        //@ts-expect-error
                        if (prev && prev?.terminal === position.terminal) {
                          console.log(prev);
                          return prev;
                        }
                        //@ts-expect-error
                        return { terminal: position.terminal, lat: position.lat, lng: position.lng };
                      })}}
                    >
                      {
                        isSelected && (
                          <InfoWindow
                            onCloseClick={() => setSelectedMarker(null)}
                          >
                            <div>
                              <h4>{selectedMarker.terminal}</h4>
                              <p>Longitude: {selectedMarker.lng}</p>
                              <p>Latitude: {selectedMarker.lat}</p>
                            </div>
                          </InfoWindow>
                        )
                      }
                    </Marker>)
                  })
                }

                {/*selectedMarker && (
                  <InfoWindow
                    position={{ lng: selectedMarker.lng, lat: selectedMarker.lat }}
                    onCloseClick={() => setSelectedMarker(null)}
                  >
                    <div>
                      <h4>Marker Info</h4>
                      <p>Lat: {selectedMarker.lat}</p>
                      <p>Lng: {selectedMarker.lng}</p>
                    </div>
                  </InfoWindow>
                )*/}
              </GoogleMap>
              :
              <></>
            }

          </Box>
        </Grid>
      </Box>
    </Box>
    {/*
    <div
      style={{
        height: 50,
        width: '100%',
        backgroundColor: '#FFFFFF',
        padding: 1.5,
        textAlign: 'center',
        boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.1)',
        flexShrink: 0,
        boxSizing: 'border-box',
      }}
    >
      <Footer />
    </div>
    */}
  </Box>
</div>


  );
}

export default Map;
